import React, { forwardRef } from "react";

import { Icon } from "../components/icon";

export const NotesIcon = forwardRef<any, any>((props, ref) => {
  const size = 16;
  const viewBox = `0 0 ${size} ${size}`;
  return (
    <Icon
      style={{ overflow: "inherit" }}
      ref={ref}
      height={size}
      width={size}
      viewBox={viewBox}
      {...props}
    >
      <g fillRule="nonzero">
        <path d="M2.16 4.32c1.19 0 2.16-.97 2.16-2.16C4.32.97 3.35 0 2.16 0 .97 0 0 .97 0 2.16c0 1.19.97 2.16 2.16 2.16zm0-2.88a.72.72 0 1 1 0 1.44.72.72 0 0 1 0-1.44zM2.16 10.08c1.19 0 2.16-.97 2.16-2.16 0-1.19-.97-2.16-2.16-2.16C.97 5.76 0 6.73 0 7.92c0 1.19.97 2.16 2.16 2.16zm0-2.88a.72.72 0 1 1 0 1.44.72.72 0 0 1 0-1.44zM2.16 15.84c1.19 0 2.16-.97 2.16-2.16 0-1.19-.97-2.16-2.16-2.16-1.19 0-2.16.97-2.16 2.16 0 1.19.97 2.16 2.16 2.16zm0-2.88a.72.72 0 1 1 0 1.44.72.72 0 0 1 0-1.44zM15.12 1.44H6.48a.72.72 0 1 0 0 1.44h8.64a.72.72 0 1 0 0-1.44zM15.12 7.2H6.48a.72.72 0 1 0 0 1.44h8.64a.72.72 0 1 0 0-1.44zM15.84 13.68a.72.72 0 0 0-.72-.72H6.48a.72.72 0 1 0 0 1.44h8.64a.72.72 0 0 0 .72-.72z" />
      </g>
    </Icon>
  );
});
